(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["actie-blok"] && !Shopify.designMode) return;
  try {
    
  /* Actieblok: zichtbaarheid tot op de seconde bijhouden. De server rendert
     een blok alleen binnen (of vlak voor) de actieperiode; dit script laat het
     precies op de begintijd verschijnen en op de eindtijd verdwijnen, ook als
     de pagina uit de cache komt of lang open staat. In de editor altijd tonen. */
  (function () {
    function bijwerken() {
      var nu = Date.now() / 1000;
      var blokken = document.querySelectorAll('[data-actie-blok]');
      for (var i = 0; i < blokken.length; i++) {
        var el = blokken[i];
        if (el.hasAttribute('data-actie-editor')) { el.hidden = false; continue; }
        var start = parseInt(el.getAttribute('data-actie-start'), 10) || 0;
        var einde = parseInt(el.getAttribute('data-actie-end'), 10) || 0;
        var zichtbaar = (!start || nu >= start) && (!einde || nu <= einde);
        if (el.hidden === zichtbaar) el.hidden = !zichtbaar;
      }
    }
    bijwerken();
    setInterval(bijwerken, 15000);
    document.addEventListener('shopify:section:load', bijwerken);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    /* De kortingscode wordt centraal afgehandeld in assets/poppedijn.js
       (toepassen via de Cart Ajax API en verrekend tonen in de winkelwagen),
       zodat de cart-pagina en de drawer exact dezelfde logica delen. */

    /* Gift wrap per product - gedelegeerd zodat het de lijst-verversing
       overleeft. Na succes de regels opnieuw renderen: het wijzigen van
       properties geeft de regel een nieuwe key, en zonder verversing zouden
       de aantal/verwijder-knoppen naar de oude key wijzen. */
    document.addEventListener('change', function (e) {
      var checkbox = e.target.closest ? e.target.closest('[data-gift-wrap-line]') : null;
      if (!checkbox) return;
      var lineKey = checkbox.dataset.giftWrapLine;
      var value = checkbox.checked ? 'ja' : '';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          properties: { 'Cadeau inpakken': value }
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.PoppedijnCart) window.PoppedijnCart.refreshItems();
        })
        .catch(function () { checkbox.checked = !checkbox.checked; });
    });

    /* Cart bundle - load recommendations */
    (function () {
      var bundle = document.querySelector('[data-cart-bundle]');
      var grid = document.querySelector('[data-cart-bundle-grid]');
      if (!bundle || !grid) return;

      function escHtml(str) {
        var d = document.createElement('div');
        d.textContent = str;
        return d.innerHTML;
      }

      /* Collect product IDs already in the cart */
      var cartProductIds = [];
      document.querySelectorAll('.cart-page__item-title[data-product-id]').forEach(function (el) {
        cartProductIds.push(String(el.dataset.productId));
      });

      /* Fetch recommendations for multiple cart items, deduplicate, show up to 12 */
      var itemLinks = document.querySelectorAll('.cart-page__item-title[data-product-id]');
      if (!itemLinks.length) return;

      var productIds = [];
      itemLinks.forEach(function (el) {
        var pid = el.dataset.productId;
        if (productIds.indexOf(pid) === -1) productIds.push(pid);
      });
      /* Limit API calls to first 4 unique products */
      productIds = productIds.slice(0, 4);

      Promise.all(productIds.map(function (pid) {
        return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10')
          .then(function (r) { return r.json(); })
          .then(function (d) { return (d && d.products) ? d.products : []; })
          .catch(function () { return []; });
      }))
        .then(function (results) {
          /* Flatten, deduplicate by id, filter out cart items */
          var seen = {};
          var all = [];
          results.forEach(function (products) {
            products.forEach(function (p) {
              if (!seen[p.id] && cartProductIds.indexOf(String(p.id)) === -1) {
                seen[p.id] = true;
                all.push(p);
              }
            });
          });

          /* Shuffle for variety, then limit to 12 */
          for (var i = all.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = all[i]; all[i] = all[j]; all[j] = tmp;
          }
          var recs = all.slice(0, 12);

          if (!recs.length) return;

          var html = '';
          recs.forEach(function (p) {
            var img = '';
            if (p.featured_image) {
              img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
            } else if (p.images && p.images[0]) {
              img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
            }
            var imgSized = img ? (img.indexOf('?') > -1 ? img : img + '?width=300') : '';
            if (imgSized && imgSized.indexOf('http') !== 0 && imgSized.indexOf('//') === 0) {
              imgSized = 'https:' + imgSized;
            }
            var rawPrice = (p.variants && p.variants[0]) ? p.variants[0].price : '0';
            var variantId = (p.variants && p.variants[0]) ? p.variants[0].id : '';
            var cents = parseFloat(rawPrice);
            var priceFormatted = '€' + (cents / 100).toFixed(2).replace('.', ',');

            html += '<div class="cart-bundle__card">'
              + '<a href="/products/' + escHtml(p.handle) + '">'
              + '<img class="cart-bundle__card-img" src="' + escHtml(imgSized) + '" alt="' + escHtml(p.title) + '" loading="lazy" width="160" height="160">'
              + '</a>'
              + '<div class="cart-bundle__card-body">'
              + '<a href="/products/' + escHtml(p.handle) + '" class="cart-bundle__card-title">' + escHtml(p.title) + '</a>'
              + '<span class="cart-bundle__card-price">' + priceFormatted + '</span>'
              + '<button type="button" class="cart-bundle__card-add" data-bundle-add="' + variantId + '">+ Toevoegen</button>'
              + '</div></div>';
          });

          grid.innerHTML = html;
          bundle.classList.add('is-loaded');

          /* Quick add to cart */
          grid.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              var vid = btn.dataset.bundleAdd;
              btn.disabled = true;
              btn.textContent = 'Toevoegen...';

              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
              })
                .then(function (r) { return r.json(); })
                .then(function () {
                  btn.textContent = '✓ Toegevoegd';
                  btn.classList.add('is-added');
                  /* Update cart count and shipping bar without page reload */
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                })
                .catch(function () {
                  btn.textContent = 'Fout';
                  btn.disabled = false;
                });
            });
          });
        })
        .catch(function () {});
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Collectietekst: Lees verder-knop alleen tonen als de tekst echt langer
     is dan de twee zichtbare regels. De volledige tekst staat altijd in de
     HTML (voor zoekmachines); dit regelt alleen de zichtbaarheid. */
  (function () {
    var wrap = document.querySelector('[data-collection-desc]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-collection-desc-text]');
    var btn = wrap.querySelector('[data-collection-desc-toggle]');
    if (!text || !btn) return;
    if (text.scrollHeight > text.clientHeight + 4) {
      wrap.classList.add('has-more');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.textContent = open ? 'Lees minder' : 'Lees verder';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();

  /* Filter panel toggle (mobile drawer) */
  (function () {
    var panel = document.querySelector('[data-filter-panel]');
    if (!panel) return;

    var toggleBtns = document.querySelectorAll('[data-filter-toggle]');
    var closeBtns = document.querySelectorAll('[data-filter-close]');

    function open() {
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggleBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });

    /* Filter group accordion */
    document.querySelectorAll('[data-filter-group-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
      });
    });

    /* Prijsfilter: Shopify's filter.v.price.gte/lte verwacht het bedrag in euro's,
       precies wat de invoervelden tonen. Geen omrekening nodig; de eerdere
       *100-conversie maakte "max 50" tot een filter op 5000 (filter deed niets). */
  })();

  /* Load more button - predictive prefetch + cascade animation */
  (function () {
    var btn = document.querySelector('[data-load-more-btn]');
    if (!btn) return;

    var grid = document.querySelector('.collection-content .grid');
    var wrapper = btn.closest('[data-load-more]');
    var countEl = wrapper.querySelector('.load-more__count');
    var textEl = btn.querySelector('.load-more__text');
    var spinnerEl = btn.querySelector('.load-more__spinner');
    var nextUrl = btn.getAttribute('data-next-url');
    var currentPage = parseInt(btn.getAttribute('data-current-page'), 10);
    var totalPages = parseInt(btn.getAttribute('data-total-pages'), 10);
    var loading = false;

    /* ── Inject animation CSS once ── */
    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.pc-enter{opacity:0;transform:translateY(12px)}' +
      '.pc-show{opacity:1;transform:translateY(0);transition:opacity .4s ease,transform .4s ease}';
    document.head.appendChild(styleEl);

    /* ═══════════════════════════════════════════════════
       SHARED HELPERS
       ═══════════════════════════════════════════════════ */

    /** Preload all primary images of off-DOM cards via new Image().
     *  Returns a promise that resolves when every image is cached (or 6 s). */
    function preloadCardImages(cards) {
      var promises = [];
      cards.forEach(function (card) {
        var imgs = card.querySelectorAll('img');
        imgs.forEach(function (img) {
          img.removeAttribute('loading');
          var src = img.getAttribute('src');
          if (!src) return;
          promises.push(new Promise(function (resolve) {
            var probe = new Image();
            probe.onload = resolve;
            probe.onerror = resolve;
            probe.src = src;
          }));
        });
      });
      var safety = new Promise(function (r) { setTimeout(r, 6000); });
      return Promise.race([Promise.all(promises), safety]);
    }

    /** Insert cards with staggered cascade animation. */
    function cascadeInsert(cards, targetGrid) {
      var fragment = document.createDocumentFragment();
      cards.forEach(function (card) { card.classList.add('pc-enter'); fragment.appendChild(card); });
      targetGrid.appendChild(fragment);
      void targetGrid.offsetHeight;
      cards.forEach(function (card, i) {
        setTimeout(function () { card.classList.add('pc-show'); }, i * 40);
      });
    }

    /** Fetch a page, parse cards, preload images. Returns promise with result object. */
    function fetchAndPreload(url) {
      return fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = Array.from(doc.querySelectorAll('.collection-content .grid > *'));
          var newBtn = doc.querySelector('[data-load-more-btn]');
          return preloadCardImages(cards).then(function () {
            return {
              cards: cards,
              nextUrl: newBtn ? newBtn.getAttribute('data-next-url') : null
            };
          });
        });
    }

    /* ═══════════════════════════════════════════════════
       PREDICTIVE PREFETCH
       Starts loading the next page + images BEFORE the
       user clicks, so the click feels instant.
       ═══════════════════════════════════════════════════ */
    var prefetched = null;   /* { cards, nextUrl } - ready to insert */
    var prefetching = null;  /* Promise - in-flight prefetch          */

    function startPrefetch() {
      if (!nextUrl || prefetched || prefetching) return;
      prefetching = fetchAndPreload(nextUrl)
        .then(function (result) { prefetched = result; })
        .catch(function () { prefetched = null; })
        .then(function () { prefetching = null; });
    }

    /* Trigger prefetch when button scrolls into view (or nearby) */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) startPrefetch();
      }, { rootMargin: '600px' });
      observer.observe(wrapper);
    } else {
      /* Fallback: prefetch after a short idle delay */
      setTimeout(startPrefetch, 2000);
    }

    /* ═══════════════════════════════════════════════════
       CLICK HANDLER - uses prefetched data if available
       ═══════════════════════════════════════════════════ */

    /** Insert fetched cards into the grid and update state.
        In volgorde toevoegen; NIET op voorraad hersorteren (de api houdt de
        globale volgorde bij, client-side hersorteren maakte de nep-bodem). */
    function insertCards(result) {
      cascadeInsert(result.cards, grid);

      currentPage++;
      countEl.textContent = currentPage + ' van ' + totalPages + " pagina's geladen";

      nextUrl = result.nextUrl;
      if (!nextUrl) {
        wrapper.remove();
      } else {
        /* Immediately start prefetching the NEXT page */
        prefetched = null;
        prefetching = null;
        startPrefetch();
      }

      loading = false;
      textEl.hidden = false;
      spinnerEl.hidden = true;
    }

    btn.addEventListener('click', function () {
      if (loading || !nextUrl) return;
      loading = true;

      if (prefetched) {
        /* ★ Instant path - data is already cached */
        var data = prefetched;
        prefetched = null;
        insertCards(data);
        return;
      }

      /* Show spinner only if we actually need to wait */
      textEl.hidden = true;
      spinnerEl.hidden = false;

      /* If prefetch is in flight, ride that promise; otherwise start fresh */
      var promise = prefetching || fetchAndPreload(nextUrl);
      prefetching = null;

      promise
        .then(function (result) {
          prefetched = null;
          insertCards(result);
        })
        .catch(function () {
          loading = false;
          textEl.hidden = false;
          spinnerEl.hidden = true;
          textEl.textContent = 'Laden mislukt, probeer opnieuw';
        });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initShuffle() {
    document.querySelectorAll('[data-fp-shuffle]').forEach(function(grid) {
      if (grid.dataset.fpShuffleInit) return;
      grid.dataset.fpShuffleInit = '1';
      var limit = parseInt(grid.dataset.fpShuffle);
      var items = Array.from(grid.querySelectorAll('.featured-products__candidate'));
      if (items.length <= limit) {
        items.forEach(function(el) { el.style.display = ''; });
        return;
      }
      /* Fisher-Yates shuffle */
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = items[i];
        items[i] = items[j];
        items[j] = temp;
      }
      /* Show first N in shuffled order, remove the rest */
      for (var k = 0; k < items.length; k++) {
        if (k < limit) {
          grid.appendChild(items[k]);
          items[k].style.display = '';
        } else {
          items[k].remove();
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShuffle);
  } else {
    initShuffle();
  }
  document.addEventListener('shopify:section:load', initShuffle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Copy discount code */
    var copyBtn = document.querySelector('[data-copy-discount]');
    function copyToClipboard(text, onSuccess) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(fallback);
      } else {
        fallback();
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;left:-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); onSuccess(); } catch (e) {}
        document.body.removeChild(ta);
      }
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.copyDiscount;
        copyToClipboard(code, function () {
          copyBtn.textContent = '✓ Gekopieerd!';
          setTimeout(function () { copyBtn.textContent = 'Kopiëren'; }, 2000);
        });
      });
    }

    /* Mark visitor as customer for smart exit popup */
    try { localStorage.setItem('poppedijn_has_purchased', '1'); } catch (e) {}

    /* Simple confetti burst on page load */
    var confettiEl = document.querySelector('[data-confetti]');
    if (confettiEl) {
      var colors = ['#ff6b6b', '#feca57', '#48dbfb', '#ff9ff3', '#54a0ff', '#5f27cd'];
      var count = 60;
      for (var i = 0; i < count; i++) {
        var particle = document.createElement('div');
        particle.style.cssText =
          'position:absolute;width:8px;height:8px;border-radius:' + (Math.random() > 0.5 ? '50%' : '1px') + ';' +
          'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
          'left:' + (Math.random() * 100) + '%;top:-10px;' +
          'animation:confetti-fall ' + (1.5 + Math.random() * 2) + 's ease-out forwards;' +
          'animation-delay:' + (Math.random() * 0.5) + 's;opacity:0;';
        confettiEl.appendChild(particle);
      }

      /* Add confetti keyframes */
      if (!document.getElementById('confetti-style')) {
        var style = document.createElement('style');
        style.id = 'confetti-style';
        style.textContent = '@keyframes confetti-fall{0%{opacity:1;transform:translateY(0) rotate(0deg) scale(1)}100%{opacity:0;transform:translateY(100vh) rotate(' + (360 + Math.random() * 360) + 'deg) scale(0.5)}}';
        document.head.appendChild(style);
      }

      /* Clean up after animation */
      setTimeout(function () { confettiEl.innerHTML = ''; }, 4000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var el = document.querySelector('[data-product-recs]');
    if (!el) return;
    var url = el.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recs]') || doc.querySelector('.product-recs');
        if (fresh && fresh.innerHTML.trim()) {
          el.outerHTML = fresh.outerHTML;
        } else {
          el.remove();
        }
      })
      .catch(function() { el.remove(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  /* Quantity buttons + limit message */
  (function () {
    var limitEl = document.querySelector('[data-qty-limit]');
    var qtyInput = document.getElementById('product-quantity');

    function showLimit(max) {
      if (!limitEl) return;
      limitEl.textContent = 'Nog ' + max + ' op voorraad';
      limitEl.hidden = false;
    }
    function hideLimit() {
      if (!limitEl) return;
      limitEl.hidden = true;
    }

    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var wrap = (minus || plus).closest('.product-page__quantity-wrap');
      var input = wrap.querySelector('.product-page__qty-input');
      var val = parseInt(input.value, 10) || 1;
      var max = input.hasAttribute('max') ? parseInt(input.max, 10) : Infinity;

      if (minus && val > 1) {
        input.value = val - 1;
        hideLimit();
      }
      if (plus) {
        if (val < max) {
          input.value = val + 1;
          if (val + 1 >= max) showLimit(max);
          else hideLimit();
        } else {
          showLimit(max);
        }
      }
    });

    /* Validate manual input */
    if (qtyInput) {
      function enforceMax() {
        var max = qtyInput.hasAttribute('max') ? parseInt(qtyInput.max, 10) : Infinity;
        var val = parseInt(qtyInput.value, 10) || 1;
        if (max !== Infinity && val > max) {
          qtyInput.value = max;
          showLimit(max);
        } else if (max !== Infinity && val === max) {
          showLimit(max);
        } else {
          hideLimit();
        }
      }
      qtyInput.addEventListener('input', enforceMax);
      qtyInput.addEventListener('change', enforceMax);
      /* Poll for Safari spinner */
      var lastQtyVal = qtyInput.value;
      setInterval(function () {
        if (qtyInput.value !== lastQtyVal) {
          lastQtyVal = qtyInput.value;
          enforceMax();
        }
      }, 150);
    }
  })();

  /* Update quantity max when variant changes */
  (function () {
    var inventoryEl = document.querySelector('[data-variant-inventory]');
    var qtyInput = document.getElementById('product-quantity');
    var selects = document.querySelectorAll('.product-page__select');
    if (!inventoryEl || !qtyInput || !selects.length) return;

    var inventory = JSON.parse(inventoryEl.textContent);
    var inventoryMap = {};
    inventory.forEach(function (v) { inventoryMap[v.id] = v; });

    var limitEl = document.querySelector('[data-qty-limit]');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var vid = parseInt(select.value, 10);
        var v = inventoryMap[vid];
        if (v && v.managed === 'shopify' && v.qty > 0) {
          qtyInput.max = v.qty;
          if (parseInt(qtyInput.value, 10) > v.qty) qtyInput.value = v.qty;
        } else {
          qtyInput.removeAttribute('max');
        }
        /* Reset qty to 1 and hide limit message on variant switch */
        qtyInput.value = 1;
        if (limitEl) limitEl.hidden = true;

        /* Prijs bijwerken (M1): hoofdprijs, doorstreepprijs en sticky-bar */
        if (v && v.price) {
          var priceWrap = document.querySelector('.product-page__price');
          if (priceWrap) {
            var cur = priceWrap.querySelector('.product-page__price-current');
            var sale = priceWrap.querySelector('.product-page__price-sale');
            var comp = priceWrap.querySelector('.product-page__price-compare');
            if (v.compare) {
              if (comp) comp.textContent = v.compare;
              if (sale) sale.textContent = v.price;
              if (cur) cur.textContent = v.price;
            } else {
              if (cur) cur.textContent = v.price;
              if (sale) sale.textContent = v.price;
            }
          }
          var stickyPrice = document.querySelector('.sticky-atc__price');
          if (stickyPrice) stickyPrice.textContent = v.price;
        }
      });
    });
  })();

  /* Tabs */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.product-tabs__tab');
    if (!tab) return;

    var container = tab.closest('.product-tabs');
    var tabName = tab.dataset.tab;

    container.querySelectorAll('.product-tabs__tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.tab === tabName);
    });
    container.querySelectorAll('.product-tabs__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === tabName);
    });
  });

  /* Sticky add to cart bar */
  (function() {
    var addBtn = document.querySelector('.product-page__add-to-cart');
    var stickyBar = document.querySelector('.sticky-atc');
    if (!addBtn || !stickyBar) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addBtn);

    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        addBtn.click();
      });
    }
  })();

  /* Stock urgency - update on variant change */
  (function () {
    var inventoryEl = document.querySelector('[data-variant-inventory]');
    var urgencyEl = document.querySelector('[data-stock-urgency]');
    var urgencyText = document.querySelector('[data-stock-urgency-text]');
    var selects = document.querySelectorAll('.product-page__select');
    if (!inventoryEl || !urgencyEl || !urgencyText || !selects.length) return;

    var inventory = JSON.parse(inventoryEl.textContent);
    var inventoryMap = {};
    inventory.forEach(function (v) { inventoryMap[v.id] = v; });

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var vid = parseInt(select.value, 10);
        var v = inventoryMap[vid];
        if (v && v.managed === 'shopify' && v.available && v.qty > 0 && v.qty <= 5) {
          urgencyText.textContent = 'Nog ' + v.qty + ' op voorraad';
          urgencyEl.hidden = false;
        } else {
          urgencyEl.hidden = true;
        }
      });
    });
  })();

  /* Back-in-stock notification form */
  (function () {
    var form = document.querySelector('[data-back-in-stock]');
    if (!form) return;
    var emailInput = form.querySelector('[data-bis-email]');
    var submitBtn = form.querySelector('[data-bis-submit]');
    var msgEl = document.querySelector('[data-bis-msg]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!email) return;

      var productTitle = form.querySelector('[name="product_title"]').value;
      var variantId = form.querySelector('[name="variant"]').value;
      var productId = form.querySelector('[name="product"]').value;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Aanmelden...';

      /* Aanmelden via de poppedijn-api, die de klant in Shopify aanmaakt of
         bijwerkt met de tags voor het dashboard Voorraad-aanvragen. Rechtstreeks
         naar Shopify's /contact posten kan niet meer: de botbescherming weigert
         script-aanvragen (403). Functioneel-noodzakelijk, geen consent-gate. */
      var apiBase = window.POPPEDIJN_API_BASE || 'https://poppedijn-api-production.up.railway.app';
      var honeypot = form.querySelector('[data-bis-website]');
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { if (controller) controller.abort(); }, 10000);

      fetch(apiBase + '/api/back-in-stock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          product: productId,
          variant: variantId,
          product_title: productTitle,
          website: honeypot ? honeypot.value : ''
        }),
        signal: controller ? controller.signal : undefined
      })
        .then(function (r) {
          clearTimeout(timer);
          return r.json().catch(function () { return {}; }).then(function (body) {
            if (!r.ok) throw new Error(body.error || 'signup failed: ' + r.status);
            form.style.display = 'none';
            if (msgEl) {
              msgEl.textContent = 'Je staat op de lijst. Zodra dit product er weer is, laat Sanne het je weten.';
              msgEl.className = 'product-page__back-in-stock-msg product-page__back-in-stock-msg--success';
              msgEl.hidden = false;
            }
          });
        })
        .catch(function (err) {
          clearTimeout(timer);
          submitBtn.disabled = false;
          submitBtn.textContent = 'Houd me op de hoogte';
          if (msgEl) {
            msgEl.textContent = (err && err.message && err.message.indexOf('signup failed') === -1 && err.name !== 'AbortError')
              ? err.message
              : 'Aanmelden lukte even niet. Probeer het zo nog eens of mail hallo@poppedijn.nl.';
            msgEl.className = 'product-page__back-in-stock-msg product-page__back-in-stock-msg--error';
            msgEl.hidden = false;
          }
        });
    });
  })();

  /* Image gallery - thumbnails (desktop) + swipe (mobile) + dots */
  (function () {
    var slider = document.querySelector('[data-gallery-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.product-page__slide');
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    var dots = document.querySelectorAll('[data-dot-index]');
    if (slides.length < 2) return;

    function goTo(index) {
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      syncIndicators(index);
    }

    function syncIndicators(index) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.thumbIndex === index); });
      dots.forEach(function (d) { d.classList.toggle('is-active', +d.dataset.dotIndex === index); });
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.dataset.slideIndex === index); });
    }

    /* Thumbnail clicks (desktop) */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(+thumb.dataset.thumbIndex); });
    });

    /* Dot clicks (mobile) */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(+dot.dataset.dotIndex); });
    });

    /* Swipe detection - IntersectionObserver for instant dot sync */
    if (window.IntersectionObserver) {
      var slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = +entry.target.dataset.slideIndex;
            syncIndicators(idx);
          }
        });
      }, { root: slider, threshold: 0.5 });
      slides.forEach(function (s) { slideObserver.observe(s); });
    }
  })();

  /* Sterren-link bovenaan opent de reviews-tab */
  (function () {
    var link = document.querySelector('[data-open-reviews]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var tab = document.querySelector('.product-tabs__tab[data-tab="reviews"]');
      if (!tab) return;
      tab.click();
      /* Niet scrollIntoView: de vaste header (plus eventuele reminder-balk)
         zou de tabkop verbergen. Zelf rekenen met de echte headerhoogte. */
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      var offset = (headerGroup ? headerGroup.offsetHeight : 0) + 16;
      var y = tab.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  /* ── Reviews: formulier + alle reviews laden ── */
  (function () {
    var section = document.querySelector('[data-product-reviews]');
    if (!section) return;
    var API = (typeof window !== 'undefined' && window.POPPEDIJN_API_BASE) || '';
    var productId = section.dataset.reviewProductId;

    /* Formulier tonen/verbergen */
    var toggle = section.querySelector('[data-review-form-toggle]');
    var form = section.querySelector('[data-review-form]');
    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var open = form.hidden;
        form.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var firstInput = form.querySelector('input[name="rating"]');
          if (firstInput) firstInput.focus();
        }
      });
    }

    /* Versturen */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = form.querySelector('[data-review-msg]');
        var btn = form.querySelector('[data-review-submit]');
        var data = new FormData(form);
        var payload = {
          product_id: productId,
          product_handle: section.dataset.reviewProductHandle,
          product_title: section.dataset.reviewProductTitle,
          rating: data.get('rating'),
          name: data.get('name'),
          email: data.get('email'),
          title: data.get('title'),
          body: data.get('body'),
          website: data.get('website')
        };
        btn.disabled = true;
        btn.textContent = 'Versturen...';

        fetch(API + '/api/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            msg.hidden = false;
            if (res.ok) {
              msg.textContent = res.json.message || 'Bedankt voor je review!';
              msg.className = 'review-form__msg review-form__msg--ok';
              form.reset();
              btn.textContent = 'Verstuurd';
            } else {
              msg.textContent = res.json.error || 'Er ging iets mis, probeer het later opnieuw.';
              msg.className = 'review-form__msg review-form__msg--error';
              btn.disabled = false;
              btn.textContent = 'Review versturen';
            }
          })
          .catch(function () {
            msg.hidden = false;
            msg.textContent = 'Er ging iets mis, probeer het later opnieuw.';
            msg.className = 'review-form__msg review-form__msg--error';
            btn.disabled = false;
            btn.textContent = 'Review versturen';
          });
      });
    }

    /* Alle reviews laden via de api (paginerend tot alles binnen is) */
    var moreBtn = section.querySelector('[data-reviews-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        moreBtn.disabled = true;
        moreBtn.textContent = 'Laden...';
        function fetchAll(offset, acc) {
          return fetch(API + '/api/reviews/product/' + encodeURIComponent(productId) + '?limit=50&offset=' + offset)
            .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.json(); })
            .then(function (data) {
              var all = acc.concat(data.reviews || []);
              if (data.reviews && data.reviews.length === 50 && all.length < data.count) {
                return fetchAll(offset + 50, all);
              }
              return all;
            });
        }
        function formatDatum(iso) {
          try {
            return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
          } catch (e) { return iso; }
        }
        fetchAll(0, [])
          .then(function (reviews) {
            var list = section.querySelector('[data-reviews-list]');
            if (!list) return;
            function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
            var html = '';
            reviews.forEach(function (r) {
              var stars = '';
              for (var i = 1; i <= 5; i++) {
                stars += '<svg width="14" height="14" viewBox="0 0 24 24" fill="' + (i <= r.rating ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.5" class="review-stars__star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
              }
              html += '<article class="product-review">' +
                '<div class="product-review__top">' +
                  '<span class="review-stars review-stars--sm"><span class="review-stars__row" aria-hidden="true">' + stars + '</span></span>' +
                  '<span class="product-review__name">' + esc(r.reviewer_name) + '</span>' +
                  (r.verified_buyer ? '<span class="product-review__verified">\u2713 Gekocht bij Poppedijn</span>' : '') +
                  '<time class="product-review__date" datetime="' + esc(r.date) + '">' + esc(formatDatum(r.date)) + '</time>' +
                '</div>' +
                (r.title ? '<h3 class="product-review__title">' + esc(r.title) + '</h3>' : '') +
                '<p class="product-review__body">' + esc(r.body).replace(/\n/g, '<br>') + '</p>' +
              '</article>';
            });
            list.innerHTML = html;
            moreBtn.remove();
          })
          .catch(function () {
            moreBtn.disabled = false;
            moreBtn.textContent = 'Alle reviews lezen';
          });
      });
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORAGE_KEY = 'poppedijn_recently_viewed';
    var MAX_ITEMS = 12;

    function getViewed() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch(e) { return []; }
    }

    function saveViewed(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
      } catch(e) {}
    }

    /* Track current product */
    var productEl = document.querySelector('[data-product-id]');
    if (productEl) {
      var id = productEl.dataset.productId;
      var items = getViewed().filter(function(item) { return item.id !== id; });
      items.unshift({
        id: id,
        url: productEl.dataset.productUrl,
        title: productEl.dataset.productTitle,
        image: productEl.dataset.productImage,
        price: productEl.dataset.productPrice,
        vendor: productEl.dataset.productVendor,
        variantId: productEl.dataset.productVariantId,
        variantCount: productEl.dataset.productVariantCount,
        available: productEl.dataset.productAvailable,
        handle: productEl.dataset.productHandle,
        ageLabel: productEl.dataset.productAgeLabel,
        ratingValue: parseFloat(productEl.dataset.productRatingValue) || 0,
        ratingCount: parseInt(productEl.dataset.productRatingCount, 10) || 0
      });
      saveViewed(items);
    }

    /* Render recently viewed */
    var section = document.querySelector('[data-recently-viewed]');
    var grid = section ? section.querySelector('[data-recently-viewed-grid]') : null;
    if (!section || !grid) return;

    var viewed = getViewed();
    var currentId = productEl ? productEl.dataset.productId : null;
    var limit = parseInt(section.dataset.limit || '4', 10);

    /* Filter out current product */
    viewed = viewed.filter(function(item) { return item.id !== currentId; });

    if (viewed.length === 0) return;

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s || '';
      return d.innerHTML;
    }

    /* Zelfde opbouw als snippets/product-card.liquid:
       merk links + leeftijd rechts, prijs links + sterren rechts */
    function ageBadgeHtml(label) {
      if (!label) return '';
      return '<span class="age-badge age-badge--sm">' +
        '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="7" r="4"/><path d="M5.5 21a6.5 6.5 0 0 1 13 0"/></svg>' +
        '<span>' + esc(label) + '</span></span>';
    }

    function starsHtml(value, count) {
      if (!count) return '';
      var rounded = Math.round(value * 2) / 2;
      var out = '<span class="review-stars review-stars--sm" aria-label="Beoordeling: ' + String(value).replace('.', ',') + ' van 5 sterren"><span class="review-stars__row" aria-hidden="true">';
      for (var i = 1; i <= 5; i++) {
        out += '<svg width="14" height="14" viewBox="0 0 24 24" fill="' + (rounded >= i ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.5" class="review-stars__star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }
      out += '</span><span class="review-stars__label">(' + count + ')</span></span>';
      return out;
    }

    var html = '';
    viewed.slice(0, limit).forEach(function(item) {
      var quickAdd = '';
      if (item.variantCount === '1' && item.available === 'true' && item.variantId) {
        quickAdd = '<button class="product-card__quick-add" data-quick-add="' + esc(item.variantId) + '" aria-label="' + esc(item.title) + ' toevoegen" onclick="event.preventDefault(); event.stopPropagation();">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '<span>Toevoegen</span></button>';
      } else if (item.variantCount !== '1' && item.available === 'true' && item.handle) {
        quickAdd = '<button class="product-card__quick-add product-card__quick-add--options" data-quick-options="' + esc(item.handle) + '" aria-label="Kies een optie voor ' + esc(item.title) + '" aria-haspopup="dialog" onclick="event.preventDefault(); event.stopPropagation();"><span>Kies optie</span></button>';
      } else if (item.variantCount !== '1' && item.available === 'true') {
        quickAdd = '<a href="' + esc(item.url) + '" class="product-card__quick-add product-card__quick-add--options" onclick="event.stopPropagation();"><span>Kies optie</span></a>';
      }

      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" class="product-card__image" width="300" height="300" loading="lazy">'
        : '<div class="product-card__placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="width:40%;opacity:0.15"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></div>';

      var metaRow = '';
      if (item.vendor || item.ageLabel) {
        metaRow = '<div class="product-card__meta-row">' +
          (item.vendor ? '<p class="product-card__vendor">' + esc(item.vendor) + '</p>' : '') +
          ageBadgeHtml(item.ageLabel) +
        '</div>';
      }

      html += '<article class="product-card">' +
        '<a href="' + esc(item.url) + '" class="product-card__link" aria-label="' + esc(item.title) + '">' +
          '<div class="product-card__image-wrap">' +
            imgHtml +
            quickAdd +
          '</div>' +
          '<div class="product-card__info">' +
            metaRow +
            '<h3 class="product-card__title">' + esc(item.title) + '</h3>' +
            '<div class="product-card__price-row">' +
              '<div class="product-card__price"><span>' + esc(item.price) + '</span></div>' +
              starsHtml(item.ratingValue, item.ratingCount) +
            '</div>' +
          '</div>' +
        '</a>' +
      '</article>';
    });

    grid.innerHTML = html;
    section.style.display = '';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  /* Show shared wishlist viewer if URL has ?list= parameter */
  (function() {
    var params = new URLSearchParams(window.location.search);
    if (params.has('list')) {
      var own = document.querySelector('[data-wishlist-page]');
      var shared = document.querySelector('[data-shared-wishlist]');
      var savedLists = document.querySelector('[data-shared-lists]');
      var detail = document.querySelector('[data-shared-detail]');
      if (own) own.style.display = 'none';
      if (savedLists) savedLists.style.display = 'none';
      if (detail) detail.style.display = 'none';
      if (shared) shared.style.display = '';
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
